import { useEffect, useState } from "react";
import { ERROR_SCENARIO_DELAY_MS } from "./errorScenarios";

// Throws while rendering for the errorRenderCrash mock scenario, so the error boundary and its error screen can be tested
const MockRenderCrash = () => {
   const [crash, setCrash] = useState(false);

   useEffect(() => {
      const timeout = setTimeout(() => setCrash(true), ERROR_SCENARIO_DELAY_MS);
      return () => clearTimeout(timeout);
   }, []);

   if (crash) {
      throw new Error("Mock scenario errorRenderCrash: render crash");
   }
   return null;
};

export default MockRenderCrash;
